module.exports = __webpack_public_path__ + "static/img/A2E_Myanmar_2017SSD.961f1b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/A2E_Myanmar_2017SSD.jpg
// module id = 9G9p
// module chunks = 0